import axios from 'axios'
import store from '@/store'
import router from '../router'
import qs from 'qs'
import JSONBIG from 'json-bigint'
import { Toast } from 'vant'

axios.defaults.timeout = 50000
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

const request = axios.create({
  baseURL: process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_SERVER_URL,
  transformResponse: [function (data) {
    // Do whatever you want to transform the data
    // 自定义后端返回的原始数据
    // data：后端返回的原始数据，就是 JSON 格式的字符串
    try {
      // data.forEach(item => {
      //   item.userId = JSONBIG.parse(item.userId)
      // })
      // console.log(JSONBIG.parse(data))
      return JSONBIG.parse(data)
    } catch (err) {
      return data
    }
    // 默认转换
    // return JSON.parse(str1)
  }]
})

// 请求拦截器
request.interceptors.request.use(config => {
  if (config.method === 'post') {
    if (config.data && config.data.userId && typeof config.data.userId === 'object') {
      config.data.userId = JSONBIG.stringify(config.data.userId)
    }
    if (config.data && config.data.orderId && typeof config.data.orderId === 'object') {
      config.data.orderId = JSONBIG.stringify(config.data.orderId)
    }
    if (config.data && config.data.packageId && typeof config.data.packageId === 'object') {
      config.data.packageId = JSONBIG.stringify(config.data.packageId)
    }
    if (config.data && config.data.packId && typeof config.data.packId === 'object') {
      config.data.packId = JSONBIG.stringify(config.data.packId)
    }
  }
  if (config.method === 'get') {
    // if (config.params.userId && typeof config.params.userId === 'object') {
    //   config.params.userId = JSONBIG.stringify(config.params.userId)
    // }
    // if (config.params.orderId && typeof config.params.orderId === 'object') {
    //   config.params.orderId = JSONBIG.stringify(config.params.orderId)
    // }
  }
  const token = store.getters.getToken
  if (config.method === 'get' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    if (token !== '' && token !== undefined) {
      config.params.token = token
    }
  } else if (config.method === 'post' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    if (token !== '' && token !== undefined) {
      config.data.token = token
    }
    config.data = qs.stringify(config.data)
  }
  if (config.url.split('/')[1] === 'Sim') {
    config.baseURL = process.env.VUE_APP_DOMAIN
  }
  return config
}, error => {
  window.console.log('错误的传参')
  return Promise.reject(error)
})

request.interceptors.response.use(res => {
  // console.log(res)
  if (res.data.code === '500') {
    store.dispatch('clearStatusFun')
    router.replace({
      path: '/'
    })
  }
  if (res.data.code === 1 && res.data.msg.indexOf('token不允许为空') !== -1) {
    router.replace({
      path: '/Login'
    })
    Toast.fail('请登录')
  }
  return res
}, error => {
  window.console.log('网络异常')
  return Promise.reject(error)
})

export default request
